<template>
  <section class="content">
    <h1
      v-if="brandName && storeName"
      style="position: absolute; top: -39px; font-size: 18px;"
      :style="$route.name === 'upProductDescription' ? 'left: 151px;' : $route.name === 'upProductAlias' ? 'left: 103px;' : 'left: 238px;'"
    >
      {{ brandName }} - {{ storeName }}
    </h1>
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box text-center">
          <div class="max-800 text-left">
            <h5><span class="text-red">＊</span> 相同料號的商品會一併新增、修改</h5>
          </div>
          <br>
          <div class="text-left max-800 m-b-10">
            <div v-for="(prod, pIndex) in prod_list" class="form block border m-y-10" style="vertical-align: top;">
              <div v-if="pIndex !== 0">
                <hr class="p-b-10" />
                <br />
              </div>
              <!-- 按鈕群組 - Start -->
              <div class="flex justify-between">
                <div class="flex m-b-10">
                  <label :for="`choose${pIndex}`" :class="['btn btn-left', prod.type === 'choose' ? 'btn-primary' : 'btn-default']">搜尋商品</label>
                  <label :for="`input${pIndex}`" :class="['btn btn-right', prod.type === 'input' ? 'btn-primary' : 'btn-default']">{{ !up ? '新增' : '編輯' }}商品</label>
                  <input v-show="false" v-model="prod.type" type="radio" :id="`choose${pIndex}`" name="type" value="choose">
                  <input v-show="false" v-model="prod.type" type="radio" :id="`input${pIndex}`" name="type" value="input">
                </div>
                <div v-if="up" class="btn btn-danger m-b-10" data-toggle="modal" data-target="#delModal">
                  <i class="fa fa-trash"></i>
                </div>
                <div v-else-if="pIndex !== 0" class="m-b-10 text-right">
                  <button class="btn btn-danger" @click="prod_list.splice(pIndex, 1)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                </div>
              </div>
              <!-- 按鈕群組 - End -->
              <div>
                <div>
                  <div class="input-group">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>商品名稱
                      <span v-if="tab === 10"> (分類)</span>
                    </span>
                    <input
                      v-if="prod.type === 'input'"
                      class="form-control"
                      type="text"
                      v-model="prod.input.item.name"
                      maxlength="32"
                      style="height: 40px"
                    >
                    <multiselect
                      v-else
                      @input="checkVenderId(prod)"
                      v-model="prod.choose.item"
                      :options="optionsList"
                      :searchable="true"
                      :allow-empty="true"
                      :close-on-select="true"
                      placeholder="請輸入商品名稱"
                      :show-labels="true"
                      :multiple="false"
                      label="name"
                      track-by="id"
                    >
                      <template slot="option" slot-scope="props">
                        <span>{{ props.option.name }}</span>
                        <span>({{ props.option.id }})</span>
                      </template>
                    </multiselect>
                    <!-- <span @click="openChooseProdModal(prod.product_name, pIndex)" class="c-pointer input-group-addon">
                      <i class="fa fa-search" aria-hidden="true"></i>
                      搜尋商品
                    </span> -->
                  </div>
                </div>
              </div>
              <br/>
              <div>
                <div>
                  <div class="input-group has-feedback max-800">
                    <span class="input-group-addon">
                      <span class="text-red">＊ </span>商品料號
                      <span v-if="tab === 10"> (分類)</span>
                    </span>
                    <input v-if="prod.type === 'input'" class="form-control" placeholder="" @focusout="checkVenderId(prod)" type="text" v-model="prod.input.item.id" maxlength="32" style="height: 40px">
                    <multiselect
                      v-else
                      @input="checkVenderId(prod)"
                      v-model="prod.choose.item"
                      :options="optionsList"
                      :searchable="true"
                      :allow-empty="true"
                      :close-on-select="true"
                      placeholder="請輸入商品料號"
                      :show-labels="true"
                      :multiple="false"
                      label="id"
                      track-by="id"
                    >
                      <template slot="option" slot-scope="props">
                        <span>{{ props.option.name }}</span>
                        <span>({{ props.option.id }})</span>
                      </template>
                    </multiselect>
                    <span v-if="!up" id="inputIconStatus" class="sr-only"></span>
                  </div>
                  <br />
                </div>
              </div>
              <div v-if="$route.name === 'upProductAlias' || !up">
                <div class="input-group max-800">
                  <span class="input-group-addon">
                    <span class="text-red" v-if="up">＊ </span>別名
                    <span v-if="tab === 10"> (分類)</span>
                  </span>
                  <input class="form-control" placeholder="" type="text" v-model="prod.alias_name" maxlength="70" style="height: 40px">
                </div>
                <br />
              </div>
              <div v-if="$route.name === 'upProductDescription' || !up" >
                <div class="input-group m-b-10 max-800" style="margin-bottom: 10px;" v-for="(prodDes, dIndex) in prod.prod_description_list">
                  <span class="input-group-addon">
                    描述
                    <span v-if="tab === 10"> (分類)</span>
                    （上限 500 字）
                  </span>
                  <textarea rows="3" class="form-control h-200" placeholder="" type="text" v-model="prodDes.prod_description" maxlength="500" />
                  <span class="c-pointer input-group-addon" v-if="dIndex === 0" @click="prod.prod_description_list.push({prod_description: ''})">
                    +
                  </span>
                  <span class="c-pointer input-group-addon" v-else @click="prod.prod_description_list.splice(dIndex, 1)">
                    -
                  </span>
                </div>
              </div>
              <br>
              <div v-if="$route.name === 'upProductDescription' || !up" >
                <div class="input-group max-800" style="margin-bottom: 10px;" v-for="(prodDes, dIndex) in prod.prod_warning_list">
                  <span class="input-group-addon">
                    <div class="warning">
                      警語
                      <span v-if="tab === 10"> (分類)</span>
                      （上限 200 字）
                    </div>
                  </span>
                  <textarea rows="3" v-model="prodDes.prod_warning" class="form-control h-200" placeholder="" type="text" maxlength="200" />
                  <span class="c-pointer input-group-addon" v-if="dIndex === 0" @click="prod.prod_warning_list.push({prod_warning: ''})">
                    +
                  </span>
                  <span class="c-pointer input-group-addon" v-else @click="prod.prod_warning_list.splice(dIndex, 1)">
                    -
                  </span>
                </div>
              </div>
              <br/>
            </div>
            <div v-if="add_prod" class="text-right">
              <button
                class="btn btn-default"
                @click="prod_list.push(JSON.parse(JSON.stringify(emptyProd)))"
              >
                ＋新增設定
              </button>
            </div>
            <br/>
          </div>
          <div class="box-footer text-center">
            <button class="btn btn-fail text-black" @click="goToBack">
              返回
            </button>
            <button class="btn btn-success" @click="checkSetting()" v-if="!up">
              新增
            </button>
            <button class="btn btn-success" @click="checkSetting()" v-else>
              更新
            </button>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
    <!-- 隱藏商品搜尋框功能
    <choose-product-modal :openModal.sync="searchModal.open" :option="chooseOption" :search="searchModal.text" @selectedProd="overwriteProduct"></choose-product-modal> -->
  </section>
</template>

<script>
// Require needed datatables modules
import bindingTable from './Temp/BindingTable'
import imgUpdateTemp from './Temp/ImgUpdateTemp'
import imgUpdateDropTemp from './Temp/ImgUpdateDropTemp'
import chooseProductModal from '@/components/elements/ChooseProductModal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CrProductSetting',
  components: {
    'choose-product-modal': chooseProductModal,
    'binding-table': bindingTable,
    'img-update': imgUpdateTemp,
    'img-up-drop': imgUpdateDropTemp
  },
  data () {
    return {
      prod_list: [], // 新增的商品別名/描述/警語
      emptyProd: {  // 完整空商品物件
        type: 'choose', // choose: 搜尋, input: 輸入
        input: {
          item: { // 為符合 choose 排版
            name: '',
            id: ''
          },
          discriptionSettingId: 0,
          aliasSettingId: 0
        },
        choose: { // 搜尋商品選項
          item: {},
          discriptionSettingId: 0,
          aliasSettingId: 0
        },
        alias_name: '',
        prod_description_list: [{ prod_description: '' }],
        prod_warning_list: [{ prod_warning: '' }]
      },
      optionsList: [], // 搜尋列表
      // searchModal: { // 搜尋商品彈窗
      //   text: '', // 搜尋文字
      //   open: false, // 開啟
      //   pIndex: '' // 商品順序
      // },
      // chooseOption: {
      //   title: '搜尋商品',
      //   id: 'searchProd'
      // },
      brandName: '',
      storeName: '',
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      is_enabled: 1,
      vendor_custom_id: '',
      product_name: '',
      alias_name: '',
      prod_description: '',
      prod_description_list: [{ prod_description: '' }],
      prod_warning_list: [{ prod_warning: '' }],
      addAmount: 5,
      settingId: '',
      type: 1, // 1 = 小圖， 2 = 大圖
      currentId: '',
      smImgSrc: '',
      up: false,
      add_prod: false,
      enableOption: [
        {label: '啟用', value: 1},
        {label: '關閉', value: 0}
      ],
      delOption: {
        id: 'delModal',
        title: '刪除描述/別名/警語',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delProductSetting'
          }
        ]
      }
    }
  },
  methods: {
    checkVenderId (prod) {
      // 判斷此料號有別名、描述或警語時，自動帶入
      // 並儲存 aliasSettingId, discriptionSettingId，表示該項目非新增，而是編輯
      const id = prod[prod.type].item.id
      if (id !== '') {
        // 描述、警語
        const durl = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/list?size=1' + '&type=' + this.tab + '&page=1' + '&vendor_custom_id_full=' + id
        this.getDataH('get', durl, null, (response) => {
          const list = response.data.list
          let prodDescriptionList = []
          let prodWarningList = []
          prod[prod.type].discriptionSettingId = list.length ? list[0].id : 0
          if (list.length) {
            list[0].item_list.forEach(item => {
              if (item.type === 1) {
                prodDescriptionList.push({ prod_description: item.description })
              } else if (item.type === 2) {
                prodWarningList.push({ prod_warning: item.description })
              }
            })
          }
          prod.prod_description_list = prodDescriptionList.length ? prodDescriptionList : [{ prod_description: '' }]
          prod.prod_warning_list = prodWarningList.length ? prodWarningList : [{ prod_warning: '' }]
        })
        // 別名
        const aurl = 'store/' + this.$route.params.store_id + '/productAliasSetting/list?size=1' + '&type=' + this.tab + '&page=1' + '&vendor_custom_id_full=' + id
        this.getDataH('get', aurl, null, (response) => {
          if (response.data.list.length) {
            prod[prod.type].aliasSettingId = response.data.list[0].id
            prod.alias_name = response.data.list[0].item_list[0].name
          }
        })
      } else {
        prod[prod.type].discriptionSettingId = 0
        prod[prod.type].aliasSettingId = 0
        prod.alias_name = ''
        prod.prod_description_list = [{ prod_description: '' }]
        prod.prod_warning_list = [{ prod_warning: '' }]
      }
    },
    trigger (event) {
      if (event === 'delProductSetting') {
        if (this.$route.name === 'upProductAlias') this.delProductAlias()
        if (this.$route.name === 'upProductDescription') this.delProductDescription()
      }
    },
    checkSetting () {
      let msg = ''
      let arr = this.prod_list
      const idList = arr.map(item => item[item.type].item.id)
      const repeatIds = idList.filter((id, index) => {
        return idList.indexOf(id) !== index
      })
      if (repeatIds.length) {
        msg = `商品料號${repeatIds.join('、')}已重複`
      } else {
        arr.every((item, i) => {
          if (!item[item.type].item.id) {
            msg = (this.add_prod ? `第${i + 1}個商品` : '') + '請輸入商品料號'
            return
          } else if (!item[item.type].item.name && this.add_prod) {
            msg = (this.add_prod ? `第${i + 1}個商品` : '') + '請輸入商品名稱'
            return
          } else if (!item.alias_name && !(item.prod_description_list[0].prod_description || item.prod_warning_list[0].prod_warning) && !this.up) {
            msg = (this.add_prod ? `第${i + 1}個商品` : '') + '請輸入商品別名或描述或警語'
            return
          } else if (this.$route.name === 'upProductAlias' && !item.alias_name) {
            msg = (this.add_prod ? `第${i + 1}個商品` : '') + '商品請輸入商品別名'
            return
          } else if (this.add_prod && item[item.type].aliasSettingId && !item.alias_name) {
            // 新增商品時，若曾有設定商品別名，則不可為空
            msg = (this.add_prod ? `第${i + 1}個商品` : '') + '商品請輸入商品別名，若需刪除請至編輯。'
            return
          } else if (this.add_prod && item[item.type].discriptionSettingId && !item.prod_description_list.length && !item.prod_warning_list.length) {
            // 新增商品時，若曾有設定商品描述或警語，則不可為空
            msg = (this.add_prod ? `第${i + 1}個商品` : '') + '商品請輸入商品描述或警語，若需刪除請至編輯。'
            return
          }
        })
      }
      this.getToast(msg)
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (this.$route.name === 'crProductSetting') {
          if (this.add_prod) this.add_multi_prod()
          else {
            if (this.alias_name) this.crProductAlias()
            else if (this.prod_description_list[0].prod_description || this.prod_warning_list[0].prod_warning) this.crProductDescription()
          }
        } else if (this.$route.name === 'upProductAlias') this.upProductAlias()
        else if (this.$route.name === 'upProductDescription') this.upProductDescription()
      }
    },
    async add_multi_prod () {
      let arr = this.prod_list
      await arr.reduce(async (i, item) => {
        this.vendor_custom_id = item[item.type].item.id
        this.product_name = item[item.type].item.name
        this.alias_name = item.alias_name
        // 若 aliasSettingId 或 discriptionSettingId 有值，則為編輯
        if (this.alias_name !== '') {
          item[item.type].aliasSettingId ? this.upProductAlias(item, item[item.type].aliasSettingId) : this.crProductAlias()
        }
        if (item.prod_description_list[0].prod_description || item.prod_warning_list[0].prod_warning) {
          this.prod_description_list = item.prod_description_list
          this.prod_warning_list = item.prod_warning_list
          item[item.type].discriptionSettingId ? this.upProductDescription(item, item[item.type].discriptionSettingId) : this.crProductDescription()
        }
      }, undefined)
      this.goProductSetting()
    },
    delProductDescription () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.goProductSetting()
        }
      })
    },
    delProductAlias () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.goProductSetting()
        }
      })
    },
    upProductDescription (item = null, id = 0) {
      var self = this
      let items = []
      let warningItems = []
      const settingId = id || this.$route.params.setting_id
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + settingId
      const prod = item || this.prod_list[0]
      prod.prod_description_list.forEach((item, i) => {
        if (item.prod_description) items.push(item.prod_description)
      })
      prod.prod_warning_list.forEach(item => {
        if (item.prod_warning) warningItems.push(item.prod_warning)
      })
      const data = {
        vendor_custom_id: prod[prod.type].item.id,
        product_name: prod[prod.type].item.name,
        is_enabled: prod.is_enabled,
        item_list: items,
        warning_list: warningItems,
        src_id_type: 1,
        type: this.tab
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.goProductSetting()
        }
      })
    },
    upProductAlias (item = null, id = 0) {
      var self = this
      const prod = item || this.prod_list[0]
      const settingId = id || this.$route.params.setting_id
      const items = [prod.alias_name]
      const url = 'store/' + this.$route.params.store_id + '/productAliasSetting/' + settingId
      const data = {
        vendor_custom_id: prod[prod.type].item.id,
        product_name: prod[prod.type].item.name,
        is_enabled: prod.is_enabled,
        item_list: items,
        src_id_type: 1,
        type: this.tab
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.goProductSetting()
        }
      })
    },
    crProductDescription () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting'
      let items = []
      let warningItem = []
      this.prod_description_list.forEach((item, i) => {
        if (item.prod_description) items.push(item.prod_description)
      })
      this.prod_warning_list.forEach((item, i) => {
        if (item.prod_warning) warningItem.push(item.prod_warning)
      })
      const data = {
        type: this.tab,
        src_id_type: 1,
        vendor_custom_id: this.vendor_custom_id,
        product_name: this.product_name,
        item_list: items,
        warning_list: warningItem
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          if (!this.add_multi_prod) self.goProductSetting()
        }
      })
    },
    crProductAlias () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting'
      const items = [this.alias_name]
      const data = {
        type: this.tab,
        src_id_type: 1,
        vendor_custom_id: this.vendor_custom_id,
        product_name: this.product_name,
        item_list: items
      }
      self.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (!self.prod_description_list[0].prod_description) {
            self.$notify({
              title: '成功',
              text: response.data.description,
              duration: 3000,
              type: 'success',
              width: 400
            })
          }
        }
      })
    },
    getProductDescription () {
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + this.$route.params.setting_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const setting = response.data.setting
          const prod = this.prod_list[0]
          prod.is_enabled = this.is_enabled
          prod['input'].item.id = setting.vendor_custom_id
          prod['input'].item.name = setting.product_name

          // TODO：將 prod_description_list 改成 []，內層不再放 {prod_description: ''}
          // 傳入描述與警語
          setting.item_list.forEach((item) => {
            if (item.description) {
              if (item.type === 1) {
                if (prod.prod_description_list[0].prod_description) {
                  prod.prod_description_list.push({ prod_description: item.description })
                } else {
                  prod.prod_description_list[0].prod_description = item.description
                }
              } else if (item.type === 2) {
                if (prod.prod_warning_list[0].prod_warning) {
                  prod.prod_warning_list.push({ prod_warning: item.description })
                } else {
                  prod.prod_warning_list[0].prod_warning = item.description
                }
              }
            }
          })

          // 判斷搜尋下拉中是否有一樣的資料
          const sameOption = this.optionsList.find((item) => {
            return (item.id === setting.vendor_custom_id) && (item.name === setting.product_name)
          })
          if (sameOption) {
            this.$nextTick(() => {
              prod['choose'].item = {
                id: setting.vendor_custom_id,
                name: setting.product_name
              }
            })
          } else {
            prod['type'] = 'input'
          }
        }
      })
    },
    getProductAlias () {
      var url = 'store/' + this.$route.params.store_id + '/productAliasSetting/' + this.$route.params.setting_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const setting = response.data.setting
          const prod = this.prod_list[0]
          prod.alias_name = setting.item_list[0].name
          prod.is_enabled = this.is_enabled
          prod['input'].item.id = setting.vendor_custom_id
          prod['input'].item.name = setting.product_name

          // 判斷搜尋下拉中是否有一樣的資料
          const sameOption = this.optionsList.find((item) => {
            return (item.id === setting.vendor_custom_id) && (item.name === setting.product_name)
          })
          if (sameOption) {
            this.$nextTick(() => {
              prod['choose'].item = {
                id: setting.vendor_custom_id,
                name: setting.product_name
              }
            })
          } else {
            prod['type'] = 'input'
          }
        }
      })
    },
    goProductSetting () {
      this.$router.push({path: `/storeTable/productSetting/${this.$route.params.brand_id}/${this.$route.params.store_id}`, query: this.$route.query})
    },
    // 隱藏商品搜尋框功能
    // openChooseProdModal (name = '', pIndex = null) {
    //   if (name.trim()) {
    //     this.searchModal.text = name.trim()
    //   }
    //   if (this.add_prod) {
    //     this.searchModal.pIndex = pIndex
    //   }
    //   this.searchModal.open = true
    // },
    // overwriteProduct (val) {
    //   // 將選擇的商品，覆蓋名稱與料號輸入框
    //   if (val.length) {
    //     if (this.add_prod) {
    //       // 新增
    //       this.prod_list[this.searchModal.pIndex].product_name = val[0].name
    //       this.prod_list[this.searchModal.pIndex].vendor_custom_id = val[0].vendor_custom_id
    //       this.checkVenderId(val[0].vendor_custom_id)
    //     } else {
    //       // 編輯
    //       this.product_name = val[0].name
    //       this.vendor_custom_id = val[0].vendor_custom_id
    //     }
    //   }
    // },
    async getMenuId () {
      // 取得該店 Menu id
      const url = 'onlineMenu/list?page=1&size=1&store_id=' + this.$route.params.store_id
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const result = response.data.menu_list
            ? response.data.menu_list[0]
              ? response.data.menu_list[0].id
              : null
            : null
          if (result) {
            this.getProductInfoList(result)
          } else {
            this.setUpAdd()
          }
        }
      })
    },
    async getProductInfoList (menuId) {
      // 取得該店商品列表 (商品名 + 料號)
      const url = 'onlineMenu/' + menuId + '/productBrief'
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.optionsList = []
          const menu = response.data.brief
          menu.category_list.forEach((category) => {
            if (this.tab === 10 && this.optionsList.findIndex(x => x.id === category.vendor_custom_id) < 0) {
              const data = {
                name: category.name,
                id: category.vendor_custom_id
              }
              this.optionsList.push(data)
            } else {
              category.child_list.forEach((prod) => {
                if (prod.type === this.tab && this.optionsList.findIndex(x => x.id === prod.vendor_custom_id) < 0) {
                  const data = {
                    name: prod.name,
                    id: prod.vendor_custom_id
                  }
                  this.optionsList.push(data)
                }
              })
            }
          })
        }
      })
      this.setUpAdd()
    },
    setUpAdd () {
      // 判斷為新增或更新
      if (this.$route.name === 'upProductAlias') {
        this.up = true
        this.getProductAlias()
      } else if (this.$route.name === 'upProductDescription') {
        this.up = true
        this.getProductDescription()
      } else if (this.$route.name === 'crProductSetting') {
        this.add_prod = true
      }
    },
    getStoreInfo () {
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const storeInfo = response.data.info
          this.brandName = storeInfo.brand_name
          this.storeName = storeInfo.name
        }
      })
    },
    goToBack () {
      // <router-link :to="({ path: `/storeTable/productSetting/${$route.params.brand_id}/${$route.params.store_id}` , query: $route.query })">
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    tab () {
      return this.$route.query.tab ? parseInt(this.$route.query.tab, 10) : 1
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    }
  },
  async created () {
    this.prod_list.push(JSON.parse(JSON.stringify(this.emptyProd)))
    await this.getMenuId()
    // 顯示 {品牌名稱 - 門市名稱}
    if (!this.$route.query.brand_name || !this.$route.query.store_name) {
      this.getStoreInfo()
    } else {
      this.brandName = this.$route.query.brand_name
      this.storeName = this.$route.query.store_name
    }
  }
}
</script>
<style lang="sass">
.max-800
  max-width: 800px
  margin: 0 auto
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>
<style lang="sass" scoped>
  table.table-bordered tbody th, table.table-bordered tbody td
    vertical-align: middle
  .btn-left
    border-start-end-radius: 0px
    border-end-end-radius: 0px
  .btn-right
    border-start-start-radius: 0px
    border-end-start-radius: 0px
  .form-control-feedback
    z-index: 0
  .has-error .multiselect
    border-radius: 5px
    border: 1px solid #a94442
  .has-success .multiselect
    border-radius: 5px
    border: 1px solid #3c763d
  .h-200
    height: 200px
</style>



// WEBPACK FOOTER //
// CrProductSetting.vue?202dc454